import { get } from "lodash";
import { ResultsEntity } from "../types/funnelback/Response";

export const getListMetadataField = (
    item: ResultsEntity,
    key: string
): string => {
    const values = item.listMetadata?.[key];
    if (Array.isArray(values) && values.length > 0) {
        return values[0];
    }
    return "";
};

export const getListMetadataFieldJoined = (
    item: ResultsEntity,
    key: string,
    separator = ", "
): string => {
    const values = item.listMetadata?.[key];
    if (!Array.isArray(values) || values.length === 0) {
        return "";
    }

    return values.map((value) => String(value).trim()).filter(Boolean).join(separator);
};

export const getResultFieldValue = (
    item: ResultsEntity,
    funnelbackField: string
): string | number | undefined => {
    if (funnelbackField.startsWith("listMetadata.")) {
        const key = funnelbackField.slice("listMetadata.".length);
        return getListMetadataField(item, key);
    }
    const value = get(item, funnelbackField);
    if (typeof value === "string" || typeof value === "number") {
        return value;
    }
    return undefined;
};
